/**
 * Redirects the browser to the ID portal's logout endpoint so the portal
 * clears its own session/token and lands the user back on the login page.
 */
export const redirectToIdPortalLogout = () => {
  const baseUrl = process.env.KINETIK_ID_PORTAL_URL;
  if (!baseUrl) {
    // eslint-disable-next-line no-console
    console.error('KINETIK_ID_PORTAL_URL not configured');
    return;
  }
  const normalizedBase = baseUrl.replace(/\/$/, '');
  window.location.assign(`${normalizedBase}/logout`);
};
